import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Gap from 'src/presentation/components/atoms/Gap';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import type BulletPointModel from 'src/domain/models/BulletPointModel';
import { SvgIconType } from '@thermenresorts/icons';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';

type BulletPointProps = {
	bulletPoint: BulletPointModel;
};

const BulletPoint = ({ bulletPoint }: BulletPointProps) => {
	const icon = bulletPoint.icon ?? SvgIconType.tick;
	const iconColor = bulletPoint.iconColor ?? Colors.green;

	return (
		<View style={styles.container}>
			<SvgIcon name={icon} size={Dimens.iconSize16} tintColor={iconColor} />
			<Gap width={Dimens.gap12} />
			<Text style={styles.bodyText}>{bulletPoint.text}</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		width: '100%',
	},
	bodyText: {
		flex: Dimens.flex1,
		fontSize: Dimens.fontSize16,
		lineHeight: Dimens.lineHeight18,
		color: Colors.gray600,
		fontFamily: Fonts.barlow,
	},
});

export default BulletPoint;
